export default initData => {
    const {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        isHybridAppContext,
        isNativeAppContext,
        splitTests,
        version
    } = initData;
    return {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        isHybridAppContext,
        isNativeAppContext,
        splitTests,
        version
    };
};
